import { render, staticRenderFns } from "./sourcing-task-stages.vue?vue&type=template&id=47bf4622&"
import script from "./sourcing-task-stages.vue?vue&type=script&lang=js&"
export * from "./sourcing-task-stages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports